import React, { Component } from 'react'

class StepFour extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }
    
    render() {
       
        return (
            <div>
                <h1>Step Four</h1>
            </div>
        );
    }
}

export default StepFour;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/betSteps/StepFour.js